import { Button } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

interface WhatsAppButtonProps {
    title?: string;
    size?: 'xs' | 'sm' | 'md' | 'lg';
    bgColor?: string;
    hoverColor?: string;
    color?: string;
}

const WhatsAppButton = ({
    title = 'Faça seu Pedido',
    size = 'md',
    bgColor = 'color.500',
    hoverColor = 'color.600',
    color = 'white',
}: WhatsAppButtonProps) => {
    const phone = '5518991646688';
    const message = encodeURIComponent(
        'Olá Donna Cegonha! Vi seus trabalhos de artesanato no site e adorei! Gostaria de saber mais sobre os produtos disponíveis. Pode me ajudar ?'
    );
    const whatsappUrl = `https://wa.me/${phone}?text=${message}`;

    return (
        <Button
            as="a"
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            leftIcon={<FontAwesomeIcon icon={faWhatsapp} />}
            bg={bgColor}
            color={color}
            _hover={{ bg: hoverColor }}
            textTransform="uppercase"
            borderRadius="full"
            px={8}
            size={size}
        >
            {title}
        </Button>
    );
};

export default WhatsAppButton;
